// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1pyAP","title":"InfoRow_title__3LWBe"};